import { Component } from 'react';
import userUtils from 'utils/User';
import Authentication from 'Authentication';
import LoveActions from 'actions/LoveActions';
import React from 'react';
import skuUtils from 'utils/Sku';
import store from 'store/Store';
import skuHelpers from 'utils/skuHelpers';
import { HEADER_VALUE } from 'constants/authentication';
import { getImageAltText } from 'utils/Accessibility';
import helpersUtils from 'utils/Helpers';

const { deferTaskExecution } = helpersUtils;

const anonymous = userUtils.isAnonymous;

const withLoveInteractions = WrappedComponent => {
    class LoveInteractions extends Component {
        constructor(props) {
            super(props);

            this.state = {
                hover: false,
                isActive: false,
                pendingSku: {}
            };

            store.setAndWatch({ 'loves.shoppingListIds': 'loves' }, this, null, store.STATE_STRATEGIES.CLIENT_SIDE_DATA);
        }

        render() {
            const { currentProduct = {}, sku = {}, loveSource, conversionType } = this.props;

            const { hover, isPending } = this.state;

            const isCustomSetsProduct =
                skuUtils.isCustomSetsSingleSkuProduct(currentProduct) || skuUtils.isCustomSetsGroupedSkuProduct(currentProduct);

            return (
                <WrappedComponent
                    skuLoveData={{
                        loveSource,
                        skuId: sku.skuId,
                        productId: currentProduct.productDetails.productId,
                        isOnlyFewLeft: sku.isOnlyFewLeft
                    }}
                    isActive={this.isActive(sku.skuId)}
                    isCustomSetsProduct={isCustomSetsProduct}
                    handleOnClick={isPending ? () => {} : this.handleOnClick}
                    mouseEnter={this.mouseEnter}
                    mouseLeave={this.mouseLeave}
                    hover={hover}
                    conversionType={conversionType}
                />
            );
        }

        isActive = skuId => {
            const { pendingSku = {} } = this.state;

            if (skuId === pendingSku.skuId) {
                return pendingSku.status === 'loved';
            }

            return skuHelpers.isSkuLoved(skuId);
        };

        setPendingSku = ({ isPending = false, skuId, status } = {}) => {
            this.setState({
                isPending,
                pendingSku: {
                    skuId,
                    status
                }
            });
        };

        showMyListsModal = isOpen => {
            store.dispatch(LoveActions.showMyListsModal(isOpen));
        };

        setSkuLoveData = skuLoveData => {
            store.dispatch(LoveActions.setSkuLoveData(skuLoveData));
        };

        setSkuLoveImageData = imageProps => {
            store.dispatch(LoveActions.setSkuLoveImageData(imageProps));
        };

        setCurrentProduct = product => {
            store.dispatch(LoveActions.setCurrentProduct(product));
        };

        handleOnClick = (e, skuLoveData) => {
            e.preventDefault();
            deferTaskExecution(() => {
                const isAnonymous = anonymous();
                let isSkuLoved;
                const { analyticsContext, sku = {} } = this.props;
                const analyticsData = {
                    context: analyticsContext,
                    nextPageContext: analyticsContext
                };
                const imageProps = {
                    id: sku.skuId,
                    skuImages: sku.skuImages,
                    disableLazyLoad: true,
                    altText: getImageAltText(sku)
                };
                Authentication.requireAuthentication(null, null, analyticsData, null, false, HEADER_VALUE.USER_CLICK)
                    .then(() => {
                        isSkuLoved = skuHelpers.isSkuLoved(sku.skuId);

                        // Don't handle love request if user was anonymous and “loved” an item that was
                        // already loved by her, since this would mark the product as unloved.
                        if (!isAnonymous || !isSkuLoved) {
                            this.showMyListsModal(true);
                            this.setSkuLoveData(skuLoveData);
                            this.setSkuLoveImageData(imageProps);
                            this.setCurrentProduct({ ...sku, ...this.props.currentProduct });
                        }
                    })
                    .catch(() => {});
            });
        };

        mouseEnter = e => {
            if (!Sephora.isTouch) {
                e.stopPropagation();
                this.setState({ hover: true });
            }
        };

        mouseLeave = e => {
            if (!Sephora.isTouch) {
                e.stopPropagation();
                this.setState({ hover: false });
            }
        };
    }

    LoveInteractions.displayName = `LoveInteractions(${WrappedComponent.displayName})`;

    return LoveInteractions;
};

export default withLoveInteractions;
